/* Packages */
import React, { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useController, useFormContext } from 'react-hook-form';
import useFlowContext from "conversie-flow-bundle/assets/js/components/flow/hooks/useFlowContext";
import { useFallbackFormContext } from 'conversie-flow-bundle/assets/js/components/flow/context/FallbackFormContext';

export default function ConversionFieldChoiceExpanded(props) {
    const isInitialRenderRef = useRef(true);
    const {
        translate = () => {},
    } = useFlowContext();

    const { colClassName, field, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, placeholder = null, value, name, errors } = field;
    const inputType = type === 'choice-radio' ? 'radio' : 'checkbox';

    const form = useFormContext();
    const fallbackForm = useFallbackFormContext();
    const {
        control,
    } = form || fallbackForm;

    const { field: { onChange, onBlur, ref }, fieldState } = useController({
        control,
        name: path,
        defaultValue: value,
        rules: {
            required: {
                value: required,
                message: translate(`conversion_flow_bundle.flow.field.error.required`),
            },
        },
    });

    const error = fieldState.error?.message || errors?.[0];

    useEffect(() => {
        if (isInitialRenderRef.current) {
            isInitialRenderRef.current = false;
            return;
        }
        onChange(value);
    }, [value]);


    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                <div className="custom-radios-grid">
                    {choices?.map((choice, choiceIndex) => {
                        return (
                            <Form.Check
                                key={choice.key}
                                className={`custom-control custom-${inputType}-expanded position-relative ${error ? 'is-error' : ''}`}
                                type={inputType}
                                id={`${id}.choices.${choiceIndex}-${choice.key}`}
                            >
                                <Form.Check.Input
                                    ref={ref}
                                    type={inputType}
                                    className="custom-control-input position-absolute visually-hidden"
                                    name={id}
                                    value={choice.key}
                                    {...{
                                        required,
                                        disabled,
                                        placeholder,
                                    }}
                                    checked={value?.includes(choice.key)}
                                    onChange={(e) => {
                                        updateChoice(choice, e.target.checked);
                                    }}
                                    onBlur={onBlur}
                                />
                                <Form.Check.Label className="custom-control-label btn" dangerouslySetInnerHTML={{ __html: choice.label }} />
                            </Form.Check>
                        );
                    })}
                </div>
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
